module.exports = __webpack_public_path__ + "img/marc-andre.1118e736.webp";